export class EstruturasPersonalizadas {
  textoFibrometal: string = '';
  usarEstruturaCalhetao: boolean = false;
  textoEstruturaCalhetao: string = '';
  usarEstruturaCarport: boolean = false;
  textoEstruturaCarport: string = '';
} 